type DefaultOptionsProps = {
  headers?: HeadersInit;
  options?: RequestInit;
};

export const API_URL = "https://api.medicair.co.uk/api";
// export const API_URL = "http://localhost:3001/api";

export const defaultOptions = (
  { headers, options }: DefaultOptionsProps = { headers: {}, options: {} }
) => ({
  headers: {
    "Content-type": "application/json",
    "authorization": `JWT ${sessionStorage.getItem("t")}`,
    ...headers,
  },
  credentials: "include" as RequestCredentials,
  cache: "no-store" as RequestCache,
  ...options,
});
